import { Link } from "react-router-dom";

const NotFound = () => (
  <section className="min-h-[80vh] bg-[#0A1628] text-white blueprint-grid flex items-center justify-center" data-testid="not-found">
    <div className="text-center px-6">
      <div className="font-display text-[140px] md:text-[220px] text-[#E8721C] leading-none">404</div>
      <h1 className="font-display text-[28px] md:text-[44px] mt-2">THIS PAGE DOESN'T EXIST.</h1>
      <p className="text-[#8A96A3] mt-3 text-[17px]">But your next supply partner does.</p>
      <Link to="/" className="btn-orange mt-8" data-testid="back-home">Back to Homepage</Link>
    </div>
  </section>
);

export default NotFound;
